<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div
        class="page-header d-flex justify-content-between align-items-center"
      >
        <h3 class="page-title">Danh sách API ↔ Quyền</h3>
        <a
          href="#"
          class="btn add-btn"
          data-toggle="modal"
          data-target="#add_modal"
        >
          <i class="fa fa-plus"></i> Thêm API Permission
        </a>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped custom-table mb-0 datatable">
            <thead>
              <tr>
                <th>Method</th>
                <th>URL Pattern</th>
                <th>Mã Quyền</th>
                <th>Tên Quyền</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in apiPermissions" :key="item.id">
                <td>{{ item.method }}</td>
                <td>{{ item.urlPattern }}</td>
                <td>{{ item.maQuyen }}</td>
                <td>{{ item.tenQuyen }}</td>
                <td class="text-right">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#edit_modal"
                        @click="editApiPermission(item)"
                      >
                        <i class="fa fa-pencil m-r-5"></i> Sửa
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#delete_modal"
                        @click="confirmDelete(item.id)"
                      >
                        <i class="fa fa-trash-o m-r-5"></i> Xóa
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="apiPermissions.length === 0 && !loading">
                <td colspan="5" class="text-center">Không có bản ghi nào.</td>
              </tr>
              <tr v-if="loading">
                <td colspan="5" class="text-center">Đang tải...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal thêm -->
    <div id="add_modal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="addApiPermission">
            <div class="modal-header">
              <h5 class="modal-title">Thêm API Permission</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Method<span class="text-danger">*</span></label>
                <input
                  v-model="newApiPerm.method"
                  class="form-control"
                  placeholder="GET, POST, PUT, DELETE..."
                  required
                />
              </div>
              <div class="form-group">
                <label>URL Pattern<span class="text-danger">*</span></label>
                <input
                  v-model="newApiPerm.urlPattern"
                  class="form-control"
                  placeholder="/api/nguoi-dung.*"
                  required
                />
              </div>
              <div class="form-group">
                <label>Chọn quyền<span class="text-danger">*</span></label>
                <select
                  v-model="newApiPerm.idQuyen"
                  class="form-control"
                  required
                >
                  <option
                    v-for="q in quyenList"
                    :key="q.idQuyen"
                    :value="q.idQuyen"
                  >
                    {{ q.maQuyen }} - {{ q.tenQuyen }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Thêm</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal sửa -->
    <div id="edit_modal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="updateApiPermission">
            <div class="modal-header">
              <h5 class="modal-title">Sửa API Permission</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Method<span class="text-danger">*</span></label>
                <input
                  v-model="currentApiPerm.method"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>URL Pattern<span class="text-danger">*</span></label>
                <input
                  v-model="currentApiPerm.urlPattern"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>Chọn quyền<span class="text-danger">*</span></label>
                <select
                  v-model="currentApiPerm.idQuyen"
                  class="form-control"
                  required
                >
                  <option
                    v-for="q in quyenList"
                    :key="q.idQuyen"
                    :value="q.idQuyen"
                  >
                    {{ q.maQuyen }} - {{ q.tenQuyen }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal xóa -->
    <div id="delete_modal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h3>Bạn có chắc muốn xóa API Permission này?</h3>
            <div class="mt-3">
              <button class="btn btn-danger mr-2" @click="deleteApiPermission">
                Xóa
              </button>
              <button class="btn btn-secondary" data-dismiss="modal">
                Hủy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import api from "@/api/index.js";
import { useToast } from "vue-toastification";

const toast = useToast();

const apiPermissions = ref([]);
const quyenList = ref([]);
const loading = ref(true);

const newApiPerm = reactive({ method: "", urlPattern: "", idQuyen: null });
const currentApiPerm = reactive({
  id: null,
  method: "",
  urlPattern: "",
  idQuyen: null,
});
const deleteId = ref(null);

const fetchApiPermissions = async () => {
  loading.value = true;
  try {
    const res = await api.get("/api/api-permission", {
      params: { page: 0, size: 150 },
    });
    apiPermissions.value = res.data.data.content;
  } catch {
    toast.error("Không thể tải danh sách API Permission");
  } finally {
    loading.value = false;
  }
};

const fetchQuyenList = async () => {
  try {
    const res = await api.get("/api/quyen", { params: { page: 0, size: 150 } });
    quyenList.value = res.data.data.content;
  } catch {
    toast.error("Không thể tải danh sách quyền");
  }
};

const addApiPermission = async () => {
  try {
    await api.post("/api/api-permission", newApiPerm);
    toast.success("Thêm thành công");
    Object.assign(newApiPerm, { method: "", urlPattern: "", idQuyen: null });
    fetchApiPermissions();
  } catch {
    toast.error("Lỗi khi thêm");
  }
};

const editApiPermission = (item) => {
  Object.assign(currentApiPerm, item);
};

const updateApiPermission = async () => {
  try {
    await api.put(`/api/api-permission/${currentApiPerm.id}`, currentApiPerm);
    toast.success("Cập nhật thành công");
    fetchApiPermissions();
  } catch {
    toast.error("Lỗi khi cập nhật");
  }
};

const confirmDelete = (id) => {
  deleteId.value = id;
};

const deleteApiPermission = async () => {
  try {
    await api.delete(`/api/api-permission/${deleteId.value}`);
    toast.success("Xóa thành công");
    $("#delete_modal").modal("hide");
    fetchApiPermissions();
  } catch {
    toast.error("Lỗi khi xóa");
  }
};

onMounted(() => {
  fetchApiPermissions();
  fetchQuyenList();
});
</script>
